import { theme } from "@theme";
import * as React from "react";
import LBox from "../../LBox";
import { useFavourites } from "@hooks/trpc/useFavourites";
import { useMemo } from "react";
import Tile from "./Tile";
import useBackendQueryEnabled from "@hooks/useBackendQueryEnabled";

const Favourites = () => {
  const { data: top10 = [] } = useFavourites();

  const top6 = useMemo(() => top10?.slice(0, 6) ?? [], [top10]);

  return (
    <LBox flex={1} flexDirection="row" flexWrap="wrap" paddingHorizontal="s4">
      {top6.map((item, i) => (
        <LBox
          key={i}
          flexBasis="50%"
          style={{
            paddingRight: i % 2 === 0 ? theme.spacing.s2 / 2 : 2,
            paddingLeft: i % 2 === 1 ? theme.spacing.s2 / 2 : 0,
          }}
          mb="s2"
        >
          <Tile favourite={item} />
        </LBox>
      ))}
    </LBox>
  );
};

const EnsureFavourites = () => {
  const { data: top10 = [] } = useFavourites();

  if (top10.length === 0) {
    return null;
  }

  return <Favourites />;
};

const OnlyLoggedInFavourites = () => {
  const enabled = useBackendQueryEnabled();

  if (!enabled) {
    return null;
  }

  return <EnsureFavourites />;
};

export default OnlyLoggedInFavourites;
